
<main id="db-wrapper">
  <app-admin-vetical-sidebar></app-admin-vetical-sidebar>
  <section id="page-content">
    <div class="header">
      <app-only-admin-navigation></app-only-admin-navigation>
    </div>
    <div *ngIf="loading">
      <app-form-spinner></app-form-spinner>
      </div>
    <div class="container" *ngIf="!loading">


      <div class="row" >
        <div class="col-lg-12">
          <div class="container">
           <div class="table-responsive">
            <table class="table bg-white">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Operation</th>
                  <th>Entity Type</th>
                  <th>Timestamp</th>
                  <th>Content</th>

                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let log of Users">
                  <td>{{ log.id }}</td>
                  <td>{{ log.operationType }}</td>
                  <td>{{ log.entityType }}</td>
                  <td>{{ log.timestamp | date :"dd-MM-YYYY:a" }}</td>
                  <td>
                    <div *ngIf="parseContent(log.content)">
                      <div *ngFor="let content of parseContent(log.content)">
                        <strong>{{ content.key }}</strong>: {{ content.value }}
                      </div>
                    </div>
                  </td>

                </tr>
              </tbody>
            </table>
           </div>


          </div>

        </div>
      </div>

    </div>
  </section>
</main>


